import { render, staticRenderFns } from "./company_list.vue?vue&type=template&id=bdad52de&scoped=true&"
import script from "./company_list.vue?vue&type=script&lang=js&"
export * from "./company_list.vue?vue&type=script&lang=js&"
import style0 from "./company_list.vue?vue&type=style&index=0&id=bdad52de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdad52de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdad52de')) {
      api.createRecord('bdad52de', component.options)
    } else {
      api.reload('bdad52de', component.options)
    }
    module.hot.accept("./company_list.vue?vue&type=template&id=bdad52de&scoped=true&", function () {
      api.rerender('bdad52de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/channelPoolVague/channelPoolDetails/form/company_list.vue"
export default component.exports